import styled from 'styled-components';

// ANIMATIONS
import { loading } from './animations';

// CONSTANTS
import { theme } from '../../constants/theme';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export const Wrapper = styled.div`
  text-align: center;
  svg {
    width: 158px;
    max-width: 100%;
    margin-bottom: 60px;
  }
`;

export const ProgressBar = styled.div`
  width: 298px;
  height: 4px;
  background: ${theme.colors.primary.transparentBorder};
  border-radius: 3px;
  position: relative;
  overflow: hidden;
  &:before {
    content: '';
    position: absolute;
    left: -50px;
    top: 0;
    bottom: 0;
    width: 100px;
    background: ${theme.colors.secondary.blue200};
    border-radius: 3px;
    animation: ${loading} 2s linear infinite;
  }
`;
